import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import './PortfolioActions.scss';
import withRouter from 'react-router/withRouter';
import { goToAddPortfolio, goToAnalysis, goToExportOption } from '../../../../../components/ClientEntry/utils';

const PortfolioActions = props => {
  const { intl, history, location, match, viewingClient, userDetails, staticContext, ...rest } = props;

  const addPolicy = () => {
    goToAddPortfolio(viewingClient, history, userDetails);
  };

  const analysis = () => {
    goToAnalysis(viewingClient, history);
  };

  const exportOption = () => {
    goToExportOption(viewingClient, history);
  };

  return viewingClient ? (
    <Grid
      className="portfolio-actions portfolio-actions-enter"
      container
      wrap="nowrap"
      {...rest}
      sx={{ flexDirection: 'column' }}
    >
      <Grid style={{ flexGrow: 1, height: '100%' }}>
        <Grid
          container
          wrap="nowrap"
          style={{ height: '100%' }}
          sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly' }}
        >
          <Grid style={{ width: '100%' }}>
            <Button
              variant="text"
              color="primary"
              fullWidth={true}
              className="pf-action pf-action-primary"
              style={{ height: 60 }}
              onClick={addPolicy}
            >
              <Grid
                container
                wrap="nowrap"
                sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
              >
                <Grid>
                  <img alt="add" src="img/add-icon.svg" width={20} />
                </Grid>
                <Grid>
                  <Typography color="primary">{intl.formatMessage({ id: 'portfo-action-add-policy' })}</Typography>
                </Grid>
              </Grid>
            </Button>
          </Grid>
          <Grid style={{ width: '100%' }}>
            <Button
              variant="text"
              color="primary"
              fullWidth={true}
              className="pf-action"
              style={{ height: 60 }}
              onClick={analysis}
            >
              <Grid
                container
                wrap="nowrap"
                sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
              >
                <Grid>
                  <img alt="export" src="img/pAnalysis_blue.svg" width={20} />
                </Grid>
                <Grid>
                  <Typography color="primary">{intl.formatMessage({ id: 'portfo-action-analy' })}</Typography>
                </Grid>
              </Grid>
            </Button>
          </Grid>
          <Grid style={{ width: '100%' }}>
            <Button
              variant="text"
              color="primary"
              fullWidth={true}
              className="pf-action"
              style={{ height: 60 }}
              onClick={exportOption}
            >
              <Grid
                container
                wrap="nowrap"
                sx={{ flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}
              >
                <Grid>
                  <img alt="export" src="img/export_blue.svg" width={20} />
                </Grid>
                <Grid>
                  <Typography color="primary">{intl.formatMessage({ id: 'portfo-action-pdf' })}</Typography>
                </Grid>
              </Grid>
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  ) : null;
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    viewingClient: state.client.viewingClient
  }),
  {}
)(PortfolioActions);

export default injectIntl(withRouter(container));
